import cx from 'classnames'

import ConfirmationModal from '../../../../../components/confirmation-modal'

import styles from './delete-card.module.scss'

const DeleteCardModal = ({
  open,
  onClose,
  onDelete,
  submitting,
  selectedCard,
}) => {
  return (
    <ConfirmationModal open={open} onClose={onClose}>
      <div style={{ padding: '24px' }}>
        <p>
          Are you sure you want to delete card{' '}
          <span className="bold">{selectedCard?.title}</span>?
        </p>
        <div className="buttons is-right">
          <button
            className={cx('button', 'is-light', styles['action-button'])}
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>

          <button
            className={cx(
              'button',
              'is-info',
              styles['action-button'],
              submitting ? 'is-loading' : '',
            )}
            onClick={() => {
              onDelete(selectedCard)
              onClose()
            }}
            type="submit"
            data-test="confirm-delete-button"
          >
            Delete
          </button>
        </div>
      </div>
    </ConfirmationModal>
  )
}

export default DeleteCardModal
